/**
 * Tiers API Service
 * Handles all tier-related API calls
 */

import apiClient from './index.js';

export class TiersApi {
  /**
   * Get list of tiers
   */
  static async getTiers(token) {
    return apiClient.get('/create/v1/tiers', token);
  }

  /**
   * Get tier details
   * @param {string} token - Auth token
   * @param {string} relId - Relative Tier ID
   */
  static async getTierDetails(token, relId) {
    return apiClient.get(`/create/v1/tiers/${relId}`, token);
  }

  /**
   * Create a new tier
   * @param {string} token - Auth token
   * @param {Object} tierData - Tier data
   */
  static async createTier(token, tierData) {
    return apiClient.post('/create/v1/tiers', token, tierData);
  }

  /**
   * Update tier
   * @param {string} token - Auth token
   * @param {Object} updateData - Update data
   */
  static async updateTier(token, updateData) {
    return apiClient.patch('/create/v1/tiers', token, updateData);
  }

  /**
   * Delete tier
   * @param {string} token - Auth token
   * @param {string} tierId - Tier ID
   * @param {string} relId - Relative Tier ID
   */
  static async deleteTier(token, tierId, relId) {
    return apiClient.delete(`/create/v1/tiers?tierId=${tierId}&relId=${relId}`, token);
  }
}

export default TiersApi;
